import React from "react";

interface ChartTooltipProps {
  active?: boolean;
  label?: string;
  /** Pre-formatted value line, e.g. "₹42,000". */
  value?: string;
  /** What the value measures, e.g. "Earnings". */
  name?: string;
  swatch?: string;
}

/**
 * Shared tooltip surface for the dashboard charts. The value wears text ink,
 * not the series color — the swatch beside it carries identity.
 */
const ChartTooltip: React.FC<ChartTooltipProps> = ({
  active,
  label,
  value,
  name,
  swatch,
}) => {
  if (!active || value === undefined) return null;

  return (
    <div className="rounded-lg border border-line bg-white px-3 py-2 shadow-md">
      {label && (
        <div className="text-[11px] text-ink-subtle mb-0.5">{label}</div>
      )}
      <div className="flex items-center gap-2">
        {swatch && (
          <span
            className="w-2.5 h-2.5 rounded-sm flex-shrink-0"
            style={{ backgroundColor: swatch }}
          />
        )}
        <span className="text-[13px] font-medium text-ink">{value}</span>
        {name && <span className="text-[12px] text-ink-muted">{name}</span>}
      </div>
    </div>
  );
};

export default ChartTooltip;
